export default function initAccordionItem() {
  Alpine.data('accordionItem', () => ({
    open: false,

    init() {
      this.$watch('open', () => {this.$root.classList.toggle('active');});
    },

    toggle() {
      this.open = !this.open;
    },
  }))
}
